export default __webpack_public_path__ + "static/media/233.bfba33f9.jpg";